import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

function App() {
  const { currentState, isVisible, currentMessage, messageAnimationTrigger } =
    useBroadcast();

  const { bg, breakDuration } = useGetParams();

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              }) center/cover no-repeat`
            : 'none',
        '--delay': `${
          isVisible && currentState && currentState === 'S1'
            ? breakDuration
            : 2000
        }ms`,
      }}>
      <div className="titre">
        <CSSTransition
          in={
            isVisible && currentMessage && currentState && currentState === 'S1'
          }
          timeout={1000}
          classNames="fade-scale"
          unmountOnExit>
          <SwitchTransition>
            <CSSTransition
              appear={true}
              key={messageAnimationTrigger}
              addEndListener={(node, done) => {
                node.addEventListener('transitionend', done, false);
              }}
              classNames="fade">
              <Message message={currentMessage?.message || {}} />
            </CSSTransition>
          </SwitchTransition>
        </CSSTransition>

        <CSSTransition
          in={
            isVisible && currentMessage && currentState && currentState === 'S1'
          }
          timeout={2000}
          classNames="fade-line"
          unmountOnExit>
          <SwitchTransition>
            <CSSTransition
              appear={true}
              key={messageAnimationTrigger}
              addEndListener={(node, done) => {
                node.addEventListener('transitionend', done, false);
              }}
              classNames="fade-line">
              <div className="line" />
            </CSSTransition>
          </SwitchTransition>
        </CSSTransition>
      </div>

      <CSSTransition
        in={
          isVisible && currentMessage && currentState && currentState === 'S1'
        }
        timeout={2000}
        classNames="fade-bgGradient"
        unmountOnExit>
        <SwitchTransition>
          <CSSTransition
            appear={true}
            key={messageAnimationTrigger}
            addEndListener={(node, done) => {
              node.addEventListener('transitionend', done, false);
            }}
            classNames="fade-bgGradient">
            <div className="bgGradient" />
          </CSSTransition>
        </SwitchTransition>
      </CSSTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
